var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import HomeService from '../../api/HomeService';
import { Loading } from 'element-ui';
var ExportDownload = (function (_super) {
    __extends(ExportDownload, _super);
    function ExportDownload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.listData = [];
        _this.total = 0;
        _this.tableHeight = 300;
        return _this;
    }
    ExportDownload.prototype.created = function () {
        this.service = HomeService.getInstance();
        this.getList();
    };
    ExportDownload.prototype.mounted = function () {
        var _this = this;
        setTimeout(function () {
            _this.tableHeight = document.documentElement.clientHeight - 211;
        }, 300);
    };
    ExportDownload.prototype.getList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.pager = pager;
        var params = {};
        Object.assign(params, pager);
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.exportLogList(params).then(function (res) {
            var data = res.data.data;
            _this.listData = data || [];
            _this.total = res.data.total;
            loadingInstance.close();
        }).catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.msg || err.message);
        });
    };
    ExportDownload.prototype.download = function (row) {
        var _this = this;
        location.href = row.url;
        if (row.status != 1) {
            return false;
        }
        this.service.exportLogDownload({ log_id: row.log_id }).then(function (res) {
            _this.getList();
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    ExportDownload.prototype.retry = function (row) {
        var _this = this;
        this.service.exportLogRetry({ log_id: row.log_id }).then(function (res) {
            _this.getList();
            _this.$message.success('已重启发起导出请求');
        }).catch(function (err) {
            _this.$message.error(err.msg || err.message);
        });
    };
    ExportDownload.prototype.pageChange = function (pager) {
        this.getList(pager);
    };
    ExportDownload = __decorate([
        Component
    ], ExportDownload);
    return ExportDownload;
}(Vue));
export default ExportDownload;
